import React, { ReactNode } from 'react';

import Typography from 'carbon-react/lib/components/typography';

import { WizardFormDivider } from '../wizard-form-divider/wizard-form-divider';

import styles from './wizard-form-help-text.scss';

interface WizardFormHelpTextProps {
  title?: ReactNode;
  text?: ReactNode;
}

export const WizardFormHelpText = ({ title, text }: WizardFormHelpTextProps) => {
  return (
    <div className={styles.container}>
      <WizardFormDivider />
      {title && (
        <Typography variant="p" fontWeight="500" mb={0} lineHeight="150%">
          {title}
        </Typography>
      )}
      {text && (
        <Typography variant="p" fontWeight="400" color="--colorsUtilityYin065" mb={0} lineHeight="150%">
          {text}
        </Typography>
      )}
    </div>
  );
};
